// doesn't work!
// import { createIconSetFromFontello } from "@expo/vector-icons";
// import auraIconConfig from "../assets/fonts/aura_config.json";
// const AuraIcon = createIconSetFromFontello(
//   auraIconConfig,
//   "aura_icons",
//   "../assets/fonts/aura_icons.ttf"
// );
//works
import { createIconSet } from "@expo/vector-icons";
const glyphMap = {
  "icon-account": 59392,
  "icon-cards": 59393,
  "icon-donate": 59394,
  "icon-entertainment": 59395,
  "icon-finance": 59396,
  "icon-flag": 59397,
  "icon-flow": 59398,
  "icon-food": 59399,
  "icon-friends": 59400,
  "icon-health": 59401,
  "icon-help": 59402,
  "icon-insurances": 59403,
  "icon-invest": 59404,
  "icon-notifications": 59406,
  "icon-other": 59407,
  "icon-plane": 59409,
  "icon-privacy": 59410,
  "icon-reports": 59411,
  "icon-search": 59412,
  "icon-settings": 59413,
  "icon-spending": 59414,
  "icon-store": 59415,
  "icon-telecommunications": 59416,
  "icon-transportation": 59417,
  "icon-travel": 59418,
  "icon-utilities": 59419,
  "icon-partners": 59408,
  "icon-megaphone": 59405,
  "icon-menu-buy": 59421,
  "icon-menu-arrow": 59425,
  "icon-menu-donate": 59422,
  "icon-menu-invest": 59423,
  "icon-arrows-ccw": 59420,
  "icon-bell": 59424,
  "icon-menu-profile": 59427,
  "icon-creditcard": 59426,
  "icon-secure": 59428,
  "icon-transactions": 59429,
  test: "∆",
};
const CustomIcon = createIconSet(
  glyphMap,
  "aura_icons",
  "../assets/fonts/aura_icons.ttf"
);

export default CustomIcon;